import { css, cx } from "@emotion/css";
import { Folder } from "lucide-react";

interface FolderColorIconProps {
	color?: string | null;
	iconClassName?: string;
	className?: string;
}

export const FolderColorIcon = ({
	color,
	iconClassName = "icon-small",
	className,
}: FolderColorIconProps) => {
	return (
		<div
			className={cx(
				"folder-color-label-icon",
				color
					? css`
							background: rgba(${color}, 0.1);
						`
					: css`
							background: var(--bgFill2);
						`,
				className,
			)}
		>
			<Folder
				className={cx(
					iconClassName,
					color &&
						css`
							color: rgb(${color});
						`,
				)}
			/>
		</div>
	);
};
